/**
 * 时间戳
 * @param {*} timestamp  时间戳
 */
const timestampToTime = timestamp => {
  let date = new Date(timestamp); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
  let Y = date.getFullYear() + "-";
  let M =
    (date.getMonth() + 1 < 10
      ? "0" + (date.getMonth() + 1)
      : date.getMonth() + 1) + "-";
  let D = (date.getDate() < 10 ? "0" + date.getDate() : date.getDate()) + " ";
  let h =
    (date.getHours() < 10 ? "0" + date.getHours() : date.getHours()) + ":";
  let m =
    (date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes()) +
    ":";
  let s = date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
  return Y + M + D + h + m + s;
};
/**
 * 存储localStorage
 */
const setStore = (name, content) => {
  if (!name) return;
  if (typeof content !== "string") {
    content = JSON.stringify(content);
  }
  window.localStorage.setItem(name, content);
};

/**
 * 获取localStorage
 */
const getStore = name => {
  if (!name) return;
  return window.localStorage.getItem(name);
};

/**
 * 删除localStorage
 */
const removeStore = name => {
  if (!name) return;
  window.localStorage.removeItem(name);
};

/**
 * 设置cookie
 **/
function setCookie(name, value, day) {
  let date = new Date();
  date.setDate(date.getDate() + day);
  document.cookie = name + "=" + value + ";expires=" + date;
}

/**
 * 获取cookie
 **/
function getCookie(name) {
  let reg = RegExp(name + "=([^;]+)");
  let arr = document.cookie.match(reg);
  if (arr) {
    return arr[1];
  } else {
    return "";
  }
}

/**
 * 删除cookie
 **/
function delCookie(name) {
  setCookie(name, "", -1);
}

function converToUrl(requestParams) {
  let params = [];
  Object.entries(requestParams).forEach(([key, value]) => {
    let param = key + "=" + value;
    params.push(param);
  });
  return params.join("&");
}

/**
 * 字符串非空判断
 */
 function getFormatString(itemObject) {
  let s = `${itemObject}`;
  if (s !== 'null' && s !== 'undefined' && s !== "" && s.length > 0) {
    return s;
  }
  return "";
}

/**
* 字符串是否非空
*/
function isString(itemObject) {
  let ob = `${getFormatString(itemObject)}`;
  if (ob != "") {
      return true;
  }
  return false;
}

/**
* 格式化时间
*/
function changeDateFormat(time, format = 'YYYY-MM-DD hh:mm:ss') {
  if(!time) return '';
  var datetime = new Date(time);
  var o = {
      'Y+': datetime.getFullYear(),
      "M+": datetime.getMonth() + 1,
      "D+": datetime.getDate(),
      "h+": datetime.getHours(),
      "m+": datetime.getMinutes(),
      "s+": datetime.getSeconds(),
      "q+": Math.floor((datetime.getMonth() + 3) / 3),
      "S": datetime.getMilliseconds()
  };
  if (/(Y+)/.test(format)) format = format.replace(RegExp.$1, (datetime.getFullYear() + "").substr(4 - RegExp.$1.length));
  for (var k in o) {
      if (new RegExp("(" + k + ")").test(format)) {
          format = format.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
      }
  }
  return format;
}

// 表格文件转json
function xlsxToJson(file) {
  return new Promise((resolve, reject) => {
    const XLSX = require("xlsx");
    // console.log(`1111111111:${XLSX}`);
    const fileReader = new FileReader();
    // console.log(`2222222222:${fileReader}`);
    fileReader.onload = function(e) {
      // console.log(`3333333333:${fileReader}`);
      try {
        const data = e.target.result; // 获取的数据
        const workBook = XLSX.read(data, { type: 'binary' }) // data转xlsx数据对象
        let sheetNames = workBook.SheetNames || [];
        // console.log(`sheetNames:${sheetNames}`);
        let sheetDatas = workBook.Sheets || [];
        // console.log(`sheetDatas:${sheetDatas}`);
        let datas = sheetDatas[sheetNames[0]];
        // console.log(`datas:${datas}`);
        let result = XLSX.utils.sheet_to_json(datas, { range: 1, defval: ' ' });// range: 2代表从第几行开始读取，defval是为空属性设置默认值
        // console.log(`result:${result}`);
        resolve(result);
      } catch (error) {
        console.log(`error:${error}`);
        reject(error);
      }
    }
    console.log(`5555555:${fileReader}`);
    fileReader.readAsBinaryString(file);
  })
}

/**
 * 导出
 **/
export {
  timestampToTime,
  setStore,
  getStore,
  removeStore,
  setCookie,
  getCookie,
  delCookie,
  converToUrl,
  getFormatString,
  isString,
  changeDateFormat,
  xlsxToJson
};



// WEBPACK FOOTER //
// ./src/utils/util.js